import { mdiArrowLeft } from '@mdi/js';
import Icon from '@mdi/react';
import React, { forwardRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import { IconButton, IconButtonProps } from '../Button/IconButton';

export type BacklinkLocationState = {
	// Create a backlink by setting location state to any icon button props, or true to use history.goBack()
	backlink?: IconButtonProps | true;
};

/**
 * Styled page title with optional backlink through location state.
 */
export const PageTitle = forwardRef<HTMLHeadingElement, {
	backlink?: IconButtonProps | true,
	className?: string,
	children: React.ReactNode
}>(({ backlink: backlinkProp, className, children }, ref) => {
	const location = useLocation<BacklinkLocationState>();
	const history = useHistory();
	const backlink = location.state?.backlink ?? backlinkProp;

	return (
		<h1
			ref={ref}
			className={clsx('flex flex-row gap-[10px] items-center mb-6 text-2xl font-medium', className)}
		>
			{backlink && (
				<div className="flex flex-row gap-1 items-center">
					<div className="size-9 flex items-center justify-center">
						<IconButton
							icon={<Icon path={mdiArrowLeft} />}
							{...(typeof backlink === 'object' && backlink)}
							{...(backlink === true && { onClick: () => history.goBack() })}
						/>
					</div>
					<div className="border-r border-borders-primary h-6 w-px" />
				</div>
			)}
			{children}
		</h1>
	);
});

PageTitle.displayName = 'PageTitle';
